import axios from 'axios';

// Authenticated download (blob) so the browser saves the file with the given name
export const downloadFile = async (url, headers, filename) => {
  const r = await axios.get(url, { headers, responseType: 'blob' });
  const href = URL.createObjectURL(r.data);
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
};

export const todayStamp = () => new Date().toLocaleDateString('sv-SE');
